import { ThinCheckmark } from '@/react/componentAssets/ThinCheckmark'
import classNames from 'classnames'
import Highlighter from 'react-highlight-words'
import { useEmployeeRowState } from './hooks/useEmployeeRowState'
import { EmployeeOrGroup } from '@/react/types/trainings'

interface EmployeeRowProps {
  employee: EmployeeOrGroup
  index: number
  search: string
  handleAssign: (employee: EmployeeOrGroup, isGroup: boolean) => void
  listToAssign: number[]
}

export const EmployeeRow = ({
  employee,
  index,
  search,
  handleAssign,
  listToAssign,
}: EmployeeRowProps) => {
  const { variableColor, hoveredField, setHoveredField } = useEmployeeRowState()
  const isGroup = 'users' in employee
  const displayName = isGroup
    ? employee.name
    : `${employee.first_name} ${employee.last_name}`

  return (
    <tr
      className={classNames(isGroup ? 'group__row' : 'project__row', {
        dark: index % 2 === 0 && !isGroup,
        light: index % 2 === 0 && isGroup,
      })}
    >
      <td
        className="name__td"
        onMouseOver={() => {
          setHoveredField({
            field__name: 'name__fullname',
            text: displayName,
            max__length: 112,
          })
        }}
        onMouseOut={() => {
          setHoveredField(null)
        }}
      >
        <Highlighter
          highlightClassName="highlighted__text"
          searchWords={[search]}
          autoEscape={true}
          textToHighlight={displayName}
        />
      </td>
      <td className="checkmark__td">
        <label className="checkbox-container">
          <input
            type="checkbox"
            checked={
              !isGroup
                ? listToAssign.includes(employee.id)
                : employee.users.every((id) => listToAssign.includes(id))
            }
            onChange={() => {
              handleAssign(employee, isGroup)
            }}
          />
          <span className="checkmark">
            <ThinCheckmark color={variableColor} />
          </span>
        </label>
      </td>
      {hoveredField &&
        hoveredField.text &&
        hoveredField.text.length > hoveredField.max__length && (
          <div className={`full__name ${hoveredField.field__name}`}>
            {hoveredField.text}
          </div>
        )}
    </tr>
  )
}
